import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { MatTabGroup, MatTabsModule } from '@angular/material/tabs';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-items-module-tabs',
  standalone: true,
  imports: [
    MatTabsModule,
    TranslateModule
  ],
  templateUrl: './items-module-tabs.component.html',
  styleUrl: './items-module-tabs.component.scss'
})
export class ItemsModuleTabsComponent {
  
  @Output() tabPanelChange = new EventEmitter<string>();
  @Input() getTabChange: number = -1;
  
  @ViewChild(MatTabGroup) tabGroup!: MatTabGroup;

  ngAfterViewInit(): void {
    if(this.tabGroup && this.getTabChange > -1) {
      const activeTab = this.tabGroup._tabs.toArray()[this.getTabChange];
      if (activeTab) {
        this.tabPanelChange.emit(activeTab.textLabel);
      }
    }
  }
}
